import { render, staticRenderFns } from "./EmphasisText.vue?vue&type=template&id=1ce76b53&scoped=true&"
import script from "./EmphasisText.vue?vue&type=script&lang=ts&"
export * from "./EmphasisText.vue?vue&type=script&lang=ts&"
import style0 from "./EmphasisText.vue?vue&type=style&index=0&id=1ce76b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce76b53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1ce76b53', component.options)
    } else {
      api.reload('1ce76b53', component.options)
    }
    module.hot.accept("./EmphasisText.vue?vue&type=template&id=1ce76b53&scoped=true&", function () {
      api.rerender('1ce76b53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/EmphasisText.vue"
export default component.exports